/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AttachAuthClientToMcpServerRequestBody,
  AttachAuthClientToMcpServerRequestBody$Outbound,
  AttachAuthClientToMcpServerRequestBody$outboundSchema,
} from "../components/attachauthclienttomcpserverrequestbody.js";

export type AttachAuthClientToMcpServerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type AttachAuthClientToMcpServerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  attachAuthClientToMcpServerRequestBody:
    AttachAuthClientToMcpServerRequestBody;
};

/** @internal */
export type AttachAuthClientToMcpServerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const AttachAuthClientToMcpServerSecurity$outboundSchema: z.ZodMiniType<
  AttachAuthClientToMcpServerSecurity$Outbound,
  AttachAuthClientToMcpServerSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function attachAuthClientToMcpServerSecurityToJSON(
  attachAuthClientToMcpServerSecurity: AttachAuthClientToMcpServerSecurity,
): string {
  return JSON.stringify(
    AttachAuthClientToMcpServerSecurity$outboundSchema.parse(
      attachAuthClientToMcpServerSecurity,
    ),
  );
}

/** @internal */
export type AttachAuthClientToMcpServerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  AttachAuthClientToMcpServerRequestBody:
    AttachAuthClientToMcpServerRequestBody$Outbound;
};

/** @internal */
export const AttachAuthClientToMcpServerRequest$outboundSchema: z.ZodMiniType<
  AttachAuthClientToMcpServerRequest$Outbound,
  AttachAuthClientToMcpServerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    attachAuthClientToMcpServerRequestBody:
      AttachAuthClientToMcpServerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      attachAuthClientToMcpServerRequestBody:
        "AttachAuthClientToMcpServerRequestBody",
    });
  }),
);

export function attachAuthClientToMcpServerRequestToJSON(
  attachAuthClientToMcpServerRequest: AttachAuthClientToMcpServerRequest,
): string {
  return JSON.stringify(
    AttachAuthClientToMcpServerRequest$outboundSchema.parse(
      attachAuthClientToMcpServerRequest,
    ),
  );
}
